import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WelcomeSplashComponent } from './welcome-splash.component';

@NgModule({
    declarations: [WelcomeSplashComponent],
    imports: [CommonModule],
    exports: [WelcomeSplashComponent],
})
export class WelcomeSplashModule {
}
